var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIcnChevronLeftBlue = function SvgIcnChevronLeftBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.354 4.646 5.5 1.5a.707.707 0 0 0-1-1L.707 4.293a1 1 0 0 0 0 1.414L4.5 9.5a.707.707 0 0 0 1-1L2.354 5.354a.5.5 0 0 1 0-.708Z",
    fill: "#13ADC7"
  })));
};

export { SvgIcnChevronLeftBlue as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDYgMTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yLjM1MzU1IDQuNjQ2NDVMNS41IDEuNUM1Ljc3NjE0IDEuMjIzODYgNS43NzYxNCAwLjc3NjE0MiA1LjUgMC41QzUuMjIzODYgMC4yMjM4NTggNC43NzYxNCAwLjIyMzg1NyA0LjUgMC41TDAuNzA3MTA3IDQuMjkyODlDMC4zMTY1ODMgNC42ODM0MiAwLjMxNjU4MiA1LjMxNjU4IDAuNzA3MTA2IDUuNzA3MTFMNC41IDkuNUM0Ljc3NjE0IDkuNzc2MTQgNS4yMjM4NiA5Ljc3NjE0IDUuNSA5LjVDNS43NzYxNCA5LjIyMzg2IDUuNzc2MTQgOC43NzYxNCA1LjUgOC41TDIuMzUzNTUgNS4zNTM1NUMyLjE1ODI5IDUuMTU4MjkgMi4xNTgyOSA0Ljg0MTcxIDIuMzUzNTUgNC42NDY0NVoiIGZpbGw9IiMxM0FEQzciLz4KPC9zdmc+Cg==";